import React, { CSSProperties, FC } from 'react';
import './chip.css';

interface ChipProps {
    className?: string;
    style?: CSSProperties;
}

const Chip: FC<ChipProps> = ({children, className, style}) => {
    return (
        <div className={`rounded-full bg-portal-blue-hover p-1 text-xs h-7 ${className}`} style={style}>
            {children}
        </div>
    );
};

export default Chip;
